import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {postCalendarChildView, putCalendarChildView} from '../../../services/calendarViews'

export async function createCalendarChildView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await postCalendarChildView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}

export async function updateCalendarChildView(dispatch, data) {
  try {
    dispatch({type: PENDING})
    let response = await putCalendarChildView(data)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Update Calendar View Failed: ${data}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
